import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import * as _ from 'lodash';

import { columns } from './columns';

import { FrontendSearchWidgetComponent } from 'shared/search-widget/frontend-search-widget.component';
import { HiddenScrollComponent } from 'shared/scroll/hidden-scroll/hidden-scroll.component';

import { ListManagerService } from 'shared/list-manager/list-manager.service';


@Component({
  moduleId: module.id,
  selector: 'product-copy-options',
  templateUrl: 'product-copy-options.component.html',
  styleUrls: ['product-copy-options.component.scss'],
  providers: [
    {provide: 'LIST_TYPE', useValue: 'item'},
    ListManagerService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCopyOptionsComponent extends FrontendSearchWidgetComponent {

  @Output() backToProducts: EventEmitter<string> = new EventEmitter();

  @ViewChild(HiddenScrollComponent, {static: false})
  hiddenScroll: HiddenScrollComponent | void;

  columns: any = columns;
  ghostValue: string = 'product-list';
  selectedAll: boolean = true;

  copyOptions = [
    {
      value: 'details',
      name: 'Details',
      selected: true,
    },
    {
      value: 'descriptions',
      name: 'Descriptions',
      selected: true,
    },
    {
      value: 'fitments',
      name: 'Fitments',
      selected: true,
    },
    {
      value: 'pricing',
      name: 'Pricing',
      selected: true,
    },
    {
      value: 'digital_assets',
      name: 'Digital Assets',
      selected: true,
    },
    {
      value: 'attributes',
      name: 'Attributes',
      selected: true,
    },
    {
      value: 'packages',
      name: 'Packaging',
      selected: true,
    },
    {
      value: 'expi_codes',
      name: 'EXPI',
      selected: true,
    },
    {
      value: 'kits',
      name: 'Kits',
      selected: true,
    },
    {
      value: 'interchange',
      name: 'Interchange',
      selected: true,
    },
    {
      value: 'custom_fields',
      name: 'Custom Fields',
      selected: true,
    },
  ];

  filtersData = [
    {
      value: 'all_product',
      name: 'All product info',
      selected: true,
    },
    {
      value: 'all_fitment',
      name: 'All fitment info',
      selected: true,
    },
  ];

  get selectedIds(): Array<any> {
    return _.map(this.selected, (item: any) => item._id);
  }

  get selectedValues(): Array<any> {
    // before init
    if (!this.data.length && this.selectedAll) {
      return _.map(this.copyOptions, (item: any) => item.value);
    }

    return _.map(this.selected, (item: any) => item.value);
  }

  get filteredIds(): Array<any> {
    return _.map(this.filterByField(this.data), (item: any) => item._id);
  }

  constructor(
    private listService: ListManagerService,
    private ref: ChangeDetectorRef,
  ) {
    super();
  }

  fetchLists(): void {
    this.data = this.copyOptions;
    _.defer(() => {
      if (this.hiddenScroll) {
        this.hiddenScroll.defineContentWidth();
      }
      this.ref.markForCheck();
    });
  }

  // handlers
  onBackToProductsClick() {
    this.backToProducts.emit();
  }

  onSelectAllChange(isSelected: boolean) {
    super.onSelectAllChange(isSelected);
    this.filtersData = this.filtersData.map(i => ({...i, selected: isSelected}));
  }

  onFiltersCheckboxChanged(item: any) {
    const isAllProductSelected = this.filtersData.find(o => o.value === 'all_product').selected;
    const isAllFitmentSelected = this.filtersData.find(o => o.value === 'all_fitment').selected;

    this.selectedAll = isAllProductSelected && isAllFitmentSelected;

    if (item.value === 'all_product') {
      _.defer(() => {
        this.data = this.data.map((i) => {
          if (i.value !== 'fitments') {
            return {
              ...i,
              selected: item.selected
            };
          } else {
            return i;
          }
        });

        this.ref.markForCheck();
      });
    }
    if (item.value === 'all_fitment') {
      _.defer(() => {
        this.data = this.data.map((i) => {
          if (i.value === 'fitments') {
            return {
              ...i,
              selected: item.selected
            };
          } else {
            return i;
          }
        });

        this.ref.markForCheck();
      });
    }
  }

  onOptionsCheckboxChanged(item: any) {
    const isAllProductSelected = !this.data.find(o => o.value !== 'fitments' && o.selected === false);
    const isAllFitmentSelected = !!this.data.find(o => o.value === 'fitments' && o.selected === true);

    this.selectedAll = isAllProductSelected && isAllFitmentSelected;

    if (item.value === 'fitments') {
      this.filtersData = this.filtersData.map((i) => {
        if (i.value === 'all_fitment') {
          return {
            ...i,
            selected: isAllFitmentSelected,
          };
        } else {
          return i;
        }
      });
    }
    if (item.value !== 'fitments') {
      this.filtersData = this.filtersData.map((i) => {
        if (i.value === 'all_product') {
          return {
            ...i,
            selected: isAllProductSelected
          };
        } else {
          return i;
        }
      });
    }
  }
}
